/* eslint import/no-anonymous-default-export: [2, {"allowObject": true}] */
export default {
  newsletterThankYou: 'newsletter.thankyou',
  newsletterError: 'newsletter.error',
  newsletterDisclaimer: 'newsletter.disclaimer',
};
